import { SHOPIFY_TOLSTOY_APP } from '@/constants/links';
import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';

export enum IntegrationRoutes {
  InstagramGraph = '/instagram-graph/instagram-graph/install',
  Tiktok = '/tiktok/tiktok/install',
}

// TODO: add tracking events
class IntegrationServiceClass {
  private apiUrl = process.env.NEXT_PUBLIC_API_URL;

  getInstallUrl = (route: IntegrationRoutes, params?: Record<string, string>) => {
    const baseUrl = `${this.apiUrl}${route}`;
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      return `${baseUrl}?${queryParams}`;
    }
    return baseUrl;
  };

  openIntegrationWindow = (route: IntegrationRoutes, params?: Record<string, string>) => {
    const url = this.getInstallUrl(route, params);
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  handleInstagramConnect = ({ appKey }) => {
    this.openIntegrationWindow(IntegrationRoutes.InstagramGraph, { appKey });
  };

  handleTiktokConnect = ({ userId, appKey }) => {
    this.openIntegrationWindow(IntegrationRoutes.Tiktok, { userId, appKey });
  };

  handleTolstoyConnect = () => {
    window.open(SHOPIFY_TOLSTOY_APP, '_blank');
  };

  actionByProvider = {
    [MediaAssetProviders.playApp]: this.handleTolstoyConnect,
    [MediaAssetProviders.instagram]: this.handleInstagramConnect,
    [MediaAssetProviders.tiktok]: this.handleTiktokConnect,
  };
}

export const IntegrationService = new IntegrationServiceClass();
